import React from 'react';
import { Archive, Home, LayoutDashboard, LogOut, ScanLine, ShieldCheck } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../config/routes';
import { useAuthStore } from '../../stores/authStore';
import { useUIStore } from '../../stores/uiStore';

export const DesktopSidebar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, can, logout } = useAuthStore();
  const openScanner = useUIStore(state => state.openScanner);
  const displayName = useUIStore(state => state.lang) === 'ar' ? user?.nameAr : user?.nameEn;

  const links = [
    { to: ROUTES.home, label: t('navigation.home'), icon: Home, end: true },
    ...(can('admin.view') ? [{ to: ROUTES.admin, label: t('navigation.admin'), icon: LayoutDashboard, end: false }] : []),
  ];

  return (
    <aside className="desktop-rail" aria-label={useUIStore.getState().lang === 'ar' ? 'التنقل الرئيسي' : 'Main navigation'}>
      <div className="rail-brand">
        <img className="brand-emblem" src="/assets/images/luxurious_gold_emblem_and_logo_design.png" alt="MASAR" />
        <div className="brand-wordmark text-lg mt-2">MASAR</div>
        <p className="brand-kicker mt-1">{t('app.name')}</p>
      </div>

      <nav className="rail-nav">
        {links.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={`${to}-${label}`} to={to} end={end} className={({ isActive }) => `rail-link${isActive ? ' active' : ''}`}>
            <Icon size={19} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
        <button type="button" className="rail-link" onClick={openScanner}>
          <ScanLine size={19} aria-hidden="true" />
          <span>{t('navigation.scan')}</span>
        </button>
        <button type="button" className="rail-link" onClick={() => navigate(ROUTES.departments)}>
          <Archive size={19} aria-hidden="true" />
          <span>{t('navigation.departments')}</span>
        </button>
      </nav>

      <div className="rail-footer">
        <div className="rail-user">
          <div className="flex items-center gap-3">
            <span className="inline-grid size-10 place-items-center rounded-xl border border-gold-500/30 bg-gold-500/10 text-gold-300"><ShieldCheck size={19} /></span>
            <div className="min-w-0">
              <p className="truncate text-sm font-bold text-champagne-100">{displayName}</p>
              <p className="truncate text-[10px] text-champagne-500">{user?.role.replace(/_/g, ' ')}</p>
            </div>
          </div>
        </div>
        <button type="button" className="rail-link text-red-300" onClick={logout}>
          <LogOut size={18} aria-hidden="true" />
          <span>{t('navigation.logout')}</span>
        </button>
        <p className="rights-line">MASAR - PH.Abdallahjawadk © 2026</p>
      </div>
    </aside>
  );
};
